// src/authConfig.js
import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
    auth: {
        clientId: "1f954d4d-8287-4324-a8cb-742142dcfa7f", // Your Application (client) ID
        authority: "https://login.microsoftonline.com/9f5475ef-7189-4427-bcbb-a51d06f5b61f", // Your Directory (tenant) ID
        redirectUri: window.location.origin, // Dynamically set to the current app's origin
        postLogoutRedirectUri: window.location.origin, // Dynamically set to the current app's origin after logout
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: "sessionStorage", // "sessionStorage" or "localStorage"
        storeAuthStateInCookie: false, // Set to true for IE11/Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        // console.info(message); // You can uncomment this for more detailed logs
                        return;
                    case LogLevel.Verbose:
                        // console.debug(message); // You can uncomment this for more detailed logs
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};

/**
 * The custom API scope exposed by this app's Entra ID app registration.
 * Configure in Azure Portal → App registrations → (this app) → Expose an API:
 *   - Application ID URI: api://1f954d4d-8287-4324-a8cb-742142dcfa7f
 *   - Add a scope named "access_as_user" (admins/users consent).
 * The API Gateway JWT authorizer must use this as its audience.
 */
export const apiConfig = {
    // Application ID URI = JWT authorizer "audience"
    audience: "api://1f954d4d-8287-4324-a8cb-742142dcfa7f",
    // Token issuer for this tenant (v2.0) = JWT authorizer "issuer"
    issuer: "https://login.microsoftonline.com/9f5475ef-7189-4427-bcbb-a51d06f5b61f/v2.0",
    scopes: ["api://1f954d4d-8287-4324-a8cb-742142dcfa7f/access_as_user"],
};

/**
 * Scopes prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * We also request the custom API scope up front so users consent once at login.
 */
export const loginRequest = {
    scopes: ["User.Read", ...apiConfig.scopes],
};

/**
 * Request used to silently acquire an access token for THIS app's backend API.
 * Note: a token for "User.Read" targets Microsoft Graph and will NOT validate
 * against the API's audience — always request apiConfig.scopes for backend calls.
 */
export const apiRequest = {
    scopes: apiConfig.scopes,
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me" // Basic endpoint to get user info
};
